(function(){
  var T=5000;
  function fmt(c){return(c/100).toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2})+' €';}

  function updateTopBar(total){
    var bar=document.getElementById('becca-top-bar');
    if(!bar)return;
    var fill=bar.querySelector('.becca-top-bar__fill');
    var text=bar.querySelector('.becca-top-bar__text');
    var truck=bar.querySelector('.becca-top-bar__truck');
    if(!fill||!text)return;
    var pct=Math.min(100,Math.round(total*100/T));
    fill.style.width=pct+'%';
    if(truck){truck.classList.remove('becca-top-bar__truck--moving');void truck.offsetWidth;truck.classList.add('becca-top-bar__truck--moving');}
    if(T-total<=0){
      text.className='becca-top-bar__text becca-top-bar__text--success';
      text.innerHTML='✨ Kostenloser Versand auf deine Bestellung!';
    }else{
      text.className='becca-top-bar__text';
      text.innerHTML='Noch <strong>'+fmt(T-total)+'</strong> bis zum kostenlosen Versand';
    }
  }

  function updateCard(id,total){
    var bar=document.getElementById(id);
    if(!bar)return;
    var fill=bar.querySelector('.becca-bar-card__fill,[id$="-fill"]');
    var label=bar.querySelector('.becca-bar-card__label,[id$="-label"]');
    var amount=bar.querySelector('.becca-bar-card__amount,[id$="-amount"]');
    var icon=bar.querySelector('.becca-bar-card__icon,[id$="-icon"]');
    if(!fill)return;
    var pct=Math.min(100,Math.round(total*100/T));
    var rem=T-total;
    fill.style.width=pct+'%';
    if(rem<=0){
      bar.classList.add('becca--success');
      if(icon)icon.textContent='✅';
      if(label){label.className='becca-bar-card__label';label.textContent='Kostenloser Versand erreicht!';}
      if(amount){amount.className='becca-bar-card__amount becca-bar-card__amount--success';amount.textContent='🎉 Gratis!';}
    }else{
      bar.classList.remove('becca--success');
      if(icon)icon.textContent='🚚';
      if(label){label.className='becca-bar-card__label';label.textContent='Noch bis zum kostenlosen Versand';}
      if(amount){amount.className='becca-bar-card__amount';amount.textContent=fmt(rem);}
    }
  }

  function updateAll(total){
    updateTopBar(total);
    updateCard('becca-drawer-bar',total);
    updateCard('becca-cart-bar',total);
  }

  function sync(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){updateAll(c.total_price);}).catch(function(){});
  }

  var _f=window.fetch;
  window.fetch=function(){
    var r=_f.apply(this,arguments);
    var u=(arguments[0]||'').toString();
    if(/\/cart\/(add|change|update)(\.js)?/.test(u))r.then(function(){setTimeout(sync,250);});
    return r;
  };

  document.addEventListener('cart:updated',function(e){
    if(e.detail&&e.detail.cart)updateAll(e.detail.cart.total_price);else sync();
  });

  var lastY=0;
  window.addEventListener('scroll',function(){
    var bar=document.getElementById('becca-top-bar');
    if(!bar)return;
    var y=window.scrollY||window.pageYOffset;
    bar.classList.toggle('becca-top-bar--hidden',y>80&&y>lastY);
    lastY=y;
  },{passive:true});

  sync();
})();
